module.exports = __webpack_public_path__ + "img/quest_icon_0060_magic2.bb1186df.png";